import React from "react";
import DragImage from "../Components/DragImage";
import "./CSS/Home.css";
import AnimatedTextWord from "../Components/AnimatedText";
import AnimatedTitle from "../Components/AnimatedTitle";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import {
  Button,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CardScatter from "../Components/CardScatter";
import { theme } from "../Components/Theme";
import FooterComp from "../Components/FooterComp";
import AnimatedTitleMobile from "../Components/AnimatedTitleMobile";

const actions = [
  { icon: <ShoppingCartIcon />, name: "Cart", path: "/cart" },
  { icon: <RestaurantIcon />, name: "Menu", path: "/menu" },
  { icon: <Avatar />, name: "Profile", path: "/profile" },
];

const Home = () => {
  return (
    <>
      <div className="desktop-content">
        <div style={{ overflow: "auto", height: "inherit", display: "block" }}>
          <div className="block">
            <ThemeProvider theme={theme}>
              <SpeedDial
                color="secondary"
                ariaLabel="SpeedDial openIcon example"
                sx={{
                  position: "fixed",
                  bottom: 40,
                  right: 30,
                }}
                icon={<SpeedDialIcon openIcon={<MenuIcon />} />}
                FabProps={{
                  size: "large",
                }}
              >
                {actions.map((action) => (
                  <SpeedDialAction
                    icon={action.icon}
                    tooltipTitle={action.name}
                    tooltipOpen
                    onClick={() => (window.location.href = action.path)}
                    FabProps={{}}
                  />
                ))}
              </SpeedDial>
            </ThemeProvider>
            <h1 className="home-title">
              <AnimatedTitle />
            </h1>
            <Link>
              <div className="gotomenu">
                <ThemeProvider theme={theme}>
                  <Link to="/menu">
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<RestaurantIcon />}
                    >
                      Order Now
                    </Button>
                  </Link>
                </ThemeProvider>
              </div>
            </Link>
            <div id="homeBanner" className="homeBanner">
              <img
                className="home-image"
                src="https://i.imgur.com/j1qEIdQ.png"
                draggable="false"
                alt="Gourmet <3"
              ></img>
              <div style={{ width: "50%" }}>
                <AnimatedTextWord
                  key={1}
                  text="Experience the CONVENENCE.  Gourmet meals on-the-go with GOURMET TAKEAWAY"
                  className="quote"
                />
              </div>
            </div>
          </div>
          <div className="track">
            <DragImage />
          </div>
          <div
            style={{
              height: "40rem",
            }}
          >
            <div
              style={{
                height: "50rem",
              }}
            >
              <div className="home-text">
                <h1 className="home-text-title">About Us</h1>
                <p className="home-text-content">
                  Takeaway is a food delivery service that provides a wide
                  variety of gourmet meals to customers. We are a team of
                  passionate foodies who are dedicated to providing the best
                  food experience to our customers. We are committed to
                  providing the best quality food and service to our customers.
                </p>
                <br />
                <p className="home-text-content-2">
                  So visit our menu and order your favourite meal today!
                </p>
              </div>
              <div className="scatter-cards">
                <CardScatter />
              </div>
            </div>
            <div>
              <FooterComp />
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-content">
        <ThemeProvider theme={theme}>
          <SpeedDial
            color="secondary"
            ariaLabel="SpeedDial openIcon example"
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
            }}
            icon={<SpeedDialIcon openIcon={<MenuIcon />} />}
            FabProps={{
              size: "large",
            }}
          >
            {actions.map((action) => (
              <SpeedDialAction
                key={action.name} // Ensure each action has a unique key
                icon={action.icon}
                tooltipTitle={action.name}
                tooltipOpen
                onClick={() => (window.location.href = action.path)}
                FabProps={{}}
              />
            ))}
          </SpeedDial>
        </ThemeProvider>
        <h1 className="home-title">
          <AnimatedTitleMobile />
        </h1>

        <div className="homeBanner">
          <img
            className="home-image"
            src="https://i.imgur.com/XIqTd5f.jpeg"
            draggable="false"
            alt="Gourmet <3"
          />
          <AnimatedTextWord
            key={1}
            text="Experience the
            CONVENIENCE
            of gourmet meals
            on-the-go with
            GOURMET TAKEAWAY"
            className="quote"
          />
        </div>
        <div className="home-text">
          <h1 className="home-text-title">About Us</h1>
          <p className="home-text-content">
            Takeaway is a food delivery service that provides a wide variety of
            gourmet meals to customers. We are a team of passionate foodies who
            are dedicated to providing the best food experience to our
            customers. We are committed to providing the best quality food and
            service to our customers.
          </p>
          <br />
          <p className="home-text-content-2">
            So visit our menu and order your favourite meal today!
          </p>
        </div>
        <div className="gotomenu">
          <ThemeProvider theme={theme}>
            <Link to="/menu">
              <Button
                sx={{ borderRadius: 10 }}
                variant="contained"
                startIcon={<RestaurantIcon />}
                size="large"
              >
                Order Now
              </Button>
            </Link>
          </ThemeProvider>
        </div>
        <div className="footer">
          <div className="content">
            <div className="info">
              <span className="title">About Us</span>
              <br />
              <span className="description">
                We are a restaurant that specializes in serving delicious food
                made from the freshest ingredients.
              </span>
            </div>
            <div className="info">
              <span className="title">Contact Us</span>
              <br />
              <span className="description">
                <span>Phone:</span> <a href="tel:123-456-7890">123-456-7890</a>{" "}
                <br />
                <span>Mail: </span>
                <a href="mailto:sample@mail.com">sample@mail.com</a>
              </span>
            </div>
            <div className="info">
              <span className="title">Hours of Operation</span>
              <br />
              <span className="description">24 Hours</span>
            </div>
            <div className="info">
              <span className="title">Location</span>
              <br />
              <span className="description">Rajlabdi</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
